//Hide CMYK/RGB/Hex
document.getElementById("Colour-Type-Selector").onchange = function () {
    var elementCMYK_C = document.getElementsByClassName("line-item-property__field")[0].style
    var elementCMYK_M = document.getElementsByClassName("line-item-property__field")[1].style
    var elementCMYK_Y = document.getElementsByClassName("line-item-property__field")[2].style
    var elementCMYK_K = document.getElementsByClassName("line-item-property__field")[3].style
    var elementRGB_R = document.getElementsByClassName("line-item-property__field")[4].style
    var elementRGB_G = document.getElementsByClassName("line-item-property__field")[5].style
    var elementRGB_B = document.getElementsByClassName("line-item-property__field")[6].style
    var elementHex = document.getElementsByClassName("line-item-property__field")[7].style
  
if (this.selectedIndex == 1) {
      elementCMYK_C.display = "block"
      elementCMYK_M.display = "block"
      elementCMYK_Y.display = "block"
      elementCMYK_K.display = "block"
      elementRGB_R.display= "none"
      elementRGB_G.display = "none"
      elementRGB_B.display = "none"
      elementHex.display = "none"
    elementCMYK_C.required = true
  
     
  } else if (this.selectedIndex == 2) {
          elementCMYK_C.display = "none"
          elementCMYK_M.display = "none"
          elementCMYK_Y.display = "none"
          elementCMYK_K.display = "none"
          elementRGB_R.display = "block"
          elementRGB_G.display = "block"
          elementRGB_B.display = "block"
          elementHex.display = "none"
  
    } else if (this.selectedIndex ==3) {
          elementCMYK_C.display = "none"
  elementCMYK_K.display = "none"
  elementCMYK_M.display = "none"
  elementCMYK_Y.display = "none"
  elementRGB_B.display = "none"
  elementRGB_G.display = "none"
  elementRGB_R.display = "none"
  elementHex.display = "block"
  
    } else {
          elementCMYK_C.display = "none"
          elementCMYK_M.display = "none"
          elementCMYK_Y.display = "none"
          elementCMYK_K.display = "none"
          elementRGB_R.display = "none"
          elementRGB_G.display = "none"
          elementRGB_B.display = "none"
  elementHex.display = "none"
    }
}